import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getMitraByNetworkCode(params) {
	return client.get("member/member-by-code", {
		params: params,
	});
}

function getMitraByIdentityNum(params) {
	return client.get("general/get-status-by-identity", {
		params: params,
	});
}

function addRegistration(params) {
	return client.post("registration", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

function checkRegistration(params) {
	return client.get("member/check-registration", {
		params: params,
	});
}

function addCloneMitra(params) {
	return client.post("binary/genealogy/clone", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getMitraByNetworkCode,
	getMitraByIdentityNum,
	addRegistration,
	checkRegistration,
	addCloneMitra
};